<template>
  <b-container fluid>
    <b-row>
     <b-col :lg="cols">
        <card>
          <TableActionHeader @filterChange="onFilterChange" @newItem="onNewItem" :newButton="$UIPrivilegeCreate('system', 'users')"></TableActionHeader> 
          <UserTable :filter="filter" @selectItem="onSelectItem"></UserTable>
        </card>
      </b-col>
      <b-col class="flex-container">
        <InfoCard  v-if="action == ''"></InfoCard>
        <card v-if="action == 'new'">
           <CardHeader :title="$t('item.new')"/>
             <UserForm :item="item" :action="action" v-on:newItem="onItemUpdated" />
        </card>
        <card v-if="action == 'item' && item"  class="settings">
          <CardHeader :title="item ? item.id: ''" type="item" />
            <tabs>
              <tab-pane title="tab-1" key="tab-1">
                 <b-icon id="settings" slot="title" icon="gear" scale='1.1'></b-icon> 
                 <b-popover target="settings" triggers="hover" placement="top">
                            {{$t("usertable.tooltips.settings")}}
                            </b-popover>
                   <UserForm :item="item" :action="action" />
              </tab-pane>

              <tab-pane title="tab-2" key="tab-2" v-if="$UIPrivilege('system', 'users', 'groups')">
                <b-icon id="groups" slot="title" icon="list-ol" scale='1.1'></b-icon> 
                <b-popover target="groups" triggers="hover" placement="top">
                            {{$t("usertable.tooltips.groups")}}
                            </b-popover>
                  <UsersGroupTable :item="item" v-on:updateItem="onItemUpdated" />
              </tab-pane>
                      
              <tab-pane title="tab-3" key="tab-3" v-if="$UIPrivilege('system', 'users', 'privileges')">
                <b-icon id="privileges" slot="title" icon="card-list" scale='1.1'></b-icon> 
                <b-popover target="privileges" triggers="hover" placement="top">
                            {{$t("usertable.tooltips.privileges")}}
                            </b-popover>
                  <TableActionHeader @filterChange="onPrivilegeFilterChange" :newButton="false"/> 
                  <UserPrivilegeTable  :filter="privilegeFilter" :item="item" />
              </tab-pane>

              <tab-pane title="tab-4" key="tab-4" v-if="$UIPrivilege('system', 'users', 'params')">
                <b-icon id="parameters" slot="title" icon="info-square" scale='1.1'></b-icon> 
                <b-popover target="parameters" triggers="hover" placement="top">
                            {{$t("usertable.tooltips.parameters")}}
                            </b-popover>
                  <UserParameterTable  :item="item" v-on:updateItem="onItemUpdated" />
              </tab-pane>
            </tabs>
          </card>
      </b-col>
     </b-row>
  </b-container>
  
</template>

<script>


import TableActionHeader from '@/components/Misc/TableActionHeader'
import CardHeader from '@/components/Misc/CardHeader'
import UserTable from '@/components/System/UserTable'
import UserForm from '@/components/System/UserForm'
import UsersGroupTable from '@/components/System/UsersGroupTable'
import UserPrivilegeTable from '@/components/System/UserPrivilegeTable'
import UserParameterTable from '@/components/System/UserParameterTable'

export default {
    components: {
        TableActionHeader, 
        CardHeader, 
        UserTable, 
        UserForm, 
        UsersGroupTable, 
        UserPrivilegeTable,
        UserParameterTable 
    },
    data() {
        return {
            cols: 8,
            filter: null,
            privilegeFilter: null,
            item: {},
            tabIndex: 1,
            action: ""
        }        
    },
    methods: {
        onFilterChange: function(filter) {
            this.filter = filter;
        },
        onPrivilegeFilterChange: function(filter) {
            this.privilegeFilter = filter;
        },
        onNewItem: function() {
            this.item = {};        
            this.action = "new"
        },
        onItemUpdated: function(item) {
            this.item = JSON.parse(JSON.stringify(item));                    
            this.action = "item"
            this.$store.dispatch('userDataHandler/getUsers');
        },
        onSelectItem: function(item) { 
            this.item = item ? JSON.parse(JSON.stringify(item)) : {};            
            this.action = item ? "item" : "";
        }
    }
    
}


</script>


<style scoped lang="scss" >

        .flex-container {
          flex-direction: column;
          align-items: center;
          width: 200px;
        }

        .settings {
          overflow:auto;
          block-size: fit-content;

        }

</style>

